import { render, staticRenderFns } from "./AccreditationPrintManager.vue?vue&type=template&id=5bc7e8fb&scoped=true&"
import script from "./AccreditationPrintManager.vue?vue&type=script&lang=js&"
export * from "./AccreditationPrintManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7e8fb",
  null
  
)

export default component.exports